import { render, staticRenderFns } from "./bianteng.vue?vue&type=template&id=191a88f3&scoped=true&"
import script from "./bianteng.vue?vue&type=script&lang=js&"
export * from "./bianteng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a88f3",
  null
  
)

export default component.exports